import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalFormService } from './digital-form.service';
import { AppService } from '../../../app.service';
import { DigitalFormDataVM, DigitalFormQuestionsCategoriesVM, DigitalFormQuestionsVM, DigitalFormVM, DigitalFormQuestionTypesVM, FormStatusTypesVM, FormHeaderVM, FlagTypesVM, UpdateQuestion, QustionHistoryVM, formUploadDate, LastFourInspectionQuestionAnswerVM, SMUUnitListVM, DigitalFormSearchVM } from '../favourite-dialog/favourite-dialog-modal';
import { DomSanitizer } from '@angular/platform-browser';
import { ClearFlagDialogComponent } from './component/clear-flag-dialog/clear-flag-dialog.component';
import { FlagCommentComponent } from './component/flag-comment/flag-comment.component';
import { NormalQuestionHistoryComponent } from './component/normal-question-history/normal-question-history.component';
import { StructuralQuestionHistoryComponent } from './component/structural-question-history/structural-question-history.component';
import { UserService } from '../../../../app/shared/services/user.service';
import { NotificationsService } from 'angular2-notifications';
import { PreferencesService } from '../../preferences/preferences.service';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { CryptoService } from '../../../services/crypto.service';
import { DigitalFormSectionQuestionsComponent } from './component/digital-form-section-questions/digital-form-section-questions.component';

@Component({
  selector: 'app-digital-form-fill',
  templateUrl: './digital-form-fill.component.html',
  styleUrls: ['./digital-form-fill.component.scss'],
    providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
  animations: [
    trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(25%)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateY(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
            ])
        ]
    )]
})


export class DigitalFormFillComponent implements OnInit {
  formId:number;
  uploadId:number;
  DigtalFormOverview:DigitalFormDataVM;
  defaultsectionQuestion : DigitalFormQuestionsVM[]=[];
  formQSections : DigitalFormQuestionsCategoriesVM[]=[];
  formQCategories : DigitalFormQuestionsCategoriesVM[]=[];
  formLastFourInspection :LastFourInspectionQuestionAnswerVM[]=[];
  formSMUUnitList:  SMUUnitListVM[]=[];
  formQuestions: DigitalFormQuestionsVM[] = [];
  formOtherQuestions: DigitalFormQuestionsVM[] = [];
  form :DigitalFormVM;
  questionTypes:DigitalFormQuestionTypesVM[]=[];
  statusTypes:FormStatusTypesVM[]=[];
  //appUris: AppUris;
  flagTypes:FlagTypesVM[];
  isSupervisour:boolean=false;
  clickButton:boolean=false;
  startDate: Date = new Date();
  summStartDate: Date = new Date();
  summEndDate: Date = new Date();
  searchParams: DigitalFormSearchVM;
  savingForm: boolean;
  workOrder: string;
  QuestionHistoryresult: QustionHistoryVM;
  showSMU: boolean=false;
  showWorkOrder: boolean=false;
  showDate: boolean=false;
  InspectionSMU:number;
  headerFormList:FormHeaderVM[];
  constructor( private _route: ActivatedRoute, private _router: Router,
    public _formService: DigitalFormService,
    public toastr: NotificationsService, vcr: ViewContainerRef,private _editPhotoDialog: MatDialog,private _user:UserService,
    private _appService: AppService,private _sanitizer: DomSanitizer,
    private readonly _pref: PreferencesService, private _crypto: CryptoService,  private _dialog: MatDialog,
    ) { }

  ngOnInit() {
    this._appService.setPageTitle('Digital Inspection- Summary');
    this.summStartDate.setMonth(this.summStartDate.getMonth() - 5)
    this.summStartDate.setDate(1);
    //this._appService.setPageSubTitle('');
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this.formId = +this._route.snapshot.paramMap.get('formId');
    this.LoadJobRoles();
    this.uploadId = +this._route.snapshot.paramMap.get('uploadId');
    if(this.formId>0 && this.uploadId>0){
      this.LoadFormUploadDetails();
    }
  }

  LoadJobRoles(){
    this._user.getUserJobRoles().subscribe(roles=>{
        roles.forEach(r => {
            switch (r.Name) {
                case 'Supervisor':
                    this.isSupervisour=true;
                    break;
            }
        });
    })
  }

  LoadFormUploadDetails() {
    this.savingForm = true;
    this.searchParams = new DigitalFormSearchVM;
    this.searchParams.FormId = this.formId;
    this.searchParams.UploadId = this.uploadId;
    this.searchParams.SummStartDate = this.summStartDate;
    this.searchParams.SummEndDate = this.summEndDate;
    this._formService.GetDigitalFormUploadDetailsByDate(this.searchParams).subscribe(res => {
      console.log(res);
      //debugger 
      this.DigtalFormOverview = res;
      console.log("DigitalFormOverview", this.DigtalFormOverview);
      this.form =this.DigtalFormOverview.DigitalForms;
      this.formLastFourInspection = res.LastFourInspectionQuestionAnswerVMList;
      this.formSMUUnitList = res.SMUUnitVMList
      this.formQCategories = this.DigtalFormOverview.ParentCategories; //.filter(x=>x.Active==true);
      this.formQSections = this.DigtalFormOverview.CategorySections; //.filter(x=>x.Active==true);
      this.formQuestions = this.DigtalFormOverview.Questions; //.filter(x=>x.Active==true);
      this.formOtherQuestions = this.DigtalFormOverview.OtherInspectionQuestions;
      //this.questionTypes=this.DigtalFormOverview.QuestionTypes;
      this.statusTypes=this.DigtalFormOverview.FormStatusList;
      this.flagTypes=this.DigtalFormOverview.FlagTypes;
      this.InspectionSMU = this.form.SMU;
      this.workOrder = this.form.WorkOrder;
      this.startDate=this.form.FormStartDate_;
      this.GetFormHeader();
      this.savingForm = false;
      this.formQCategories.forEach(cat => {
        cat.Sections = this.formQSections.filter(sect => sect.ParentCatId === cat.QuestionCatId);
        cat.Sections.forEach(sect => {
          sect.Questions = this.formQuestions.filter(q => q.QuestionCatId === sect.QuestionCatId);
        });
        cat.AllQuestions = cat.Sections.reduce((acc, section) => acc.concat(section.Questions), []);
        console.log("CATEGORY:", cat.QCategoryName, cat);
      });
      this.prepareQuestionAnswers();
    });

  }
  prepareQuestionAnswers() {
  this.formQuestions.forEach(q => {
    if (q.QuestionTypeId === 3 ) {
      console.log('q.QuestionTypeId',q.QuestionTypeId);
      q.AnswerArray = q.Answer
        .split('%')
        .map(a => a.trim())
        .filter(a => a.length > 0)
        .map(a => ({
          full: a,
          display: a.length > 10 ? a.slice(0, 10) + '...' : a,
          hasTooltip: a.length > 10
        }));
        console.log('abjs');
    } else {
      q.AnswerArray = [];
    }
    console.log('console.log(q.AnswerArray)', q.AnswerArray);
  });

}


  StatusColor(status:string){
    if(status=="In Progress"){
      return 'status-orange'
    }
    if(status=="Complete"){
      return 'status-green'
    }
    if(status=="Not Started"){
      return 'status-red'
    }
  }

  OpenOveralNotes(){
    const addSectionDialog = this._editPhotoDialog.open(FlagCommentComponent, {
      data: {
        comment:null,
        exsitingcomment:this.form.Notes,
        header:"Notes History",
        isInstructions:false,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if(details.Id>0){
        //Update Comment
        this._formService.UpdateUploadOverallComment(this.uploadId,details.Comment).subscribe(res=>{
          if(res){
            this.toastr.success("Sucessfully update General Note")
            this.LoadFormUploadDetails()
          }
        })
      }
    });
  }

  OpenQuestionHistory(QId: number, UploadId: number) {
    this._formService.GETSelectedQuestionHistory(QId, this.form.EquipmentId, UploadId).subscribe(res=>{
      // console.log("result___History",res)
      this.QuestionHistoryresult = res;
      const addSectionDialog = this._editPhotoDialog.open(NormalQuestionHistoryComponent, {
        width: '1000px',
        height:'660px',
        data: {
          QuestionHistoryresult:this.QuestionHistoryresult,
        }
      });
      addSectionDialog.afterClosed().subscribe(details => {
        this.LoadFormUploadDetails();
      });
    });
  }

  OpenQuestionHistoryStructural(QId: number, UploadId: number){
    this._formService.GETSelectedStructuaralQuestionHistory(QId, this.form.EquipmentId, UploadId).subscribe(res=>{
    //  console.log("result___History_Structural",res) 
      this.QuestionHistoryresult = res;
      const addSectionDialog = this._editPhotoDialog.open(StructuralQuestionHistoryComponent, {
        width: '900px',
        height:'700px',
        data: {
          QuestionHistoryresult:this.QuestionHistoryresult,
        }
      });
      addSectionDialog.afterClosed().subscribe(details => {
        this.LoadFormUploadDetails();
      });
    });
  }

  GetFlagTitle(question:DigitalFormQuestionsVM){
    let flagId =question.QuestionFlag;
   let flag= this.flagTypes.find(x=>x.ID==flagId);
   let flagname = flag.Name;
   return flagname;
  }

  GetColor(question:DigitalFormQuestionsVM){
    let color =question.FlagColor;
    return color;
  }

  UpdateFlag(type:FlagTypesVM, Question:DigitalFormQuestionsVM){
    // console.log("type", type)
    this.clickButton=true;
    Question.ClearFlag=false;
    Question.QuestionFlag=type.ID;
    Question.FlagColor=type.Color;
    Question.UploadId = Question.UploadId;
    let UpdateQuestions = new DigitalFormQuestionsVM();
    UpdateQuestions = Question;
    this._formService.UpdateQuestionsFlag(UpdateQuestions).subscribe(res=>{
      if(res){
        this.LoadFormUploadDetails();
      }
    })
  }

  OpenEqDetails(){
    window.open('/dfi-implementdetails/' + this.form.EquipmentId, '_blank');
  }

  CompleteFlag(Question:DigitalFormQuestionsVM){
    this.clickButton=true;
    Question.ClearFlag=false;
    // console.log("flagggg Question")
    const addSectionDialog = this._editPhotoDialog.open(ClearFlagDialogComponent, {
      data: {
        comment: Question.FlagClearComment,
        flagClear:Question.ClearFlag,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details.Id>0) {
        Question.updateFlag=true;
        //console.log("details___", details)
        if(details.Id==1)//clear the flag
        {
          Question.ClearFlag=true;
          Question.FlagClearComment=details.Comment;
          let color =this.flagTypes.find(x=>x.ID== Question.QuestionFlag);
          Question.FlagColor=color.CompleteColor;
        }
        if(details.Id==2){ //update the flag comment
          Question.ClearFlag=false;
          Question.FlagClearComment=details.Comment;
        }
        if(details.Id==3){// reset the flag
          Question.ClearFlag=false;
          Question.FlagClearComment=details.Comment;
          let color =this.flagTypes.find(x=>x.ID== Question.QuestionFlag);
          Question.FlagColor = color.Color;
          Question.QuestionFlag
        }
        let UpdateQuestions = new DigitalFormQuestionsVM();
        UpdateQuestions = Question;
        UpdateQuestions.UploadId = Question.UploadId;
        UpdateQuestions.FormId=this.formId;
        this._formService.UpdateQuestionsFlag(UpdateQuestions).subscribe(res=>{
          if(res){
            this.LoadFormUploadDetails();
          }
        })
      }else{
      }
    });
  }

  GetFormHeader(){
    this._formService.GetDigitalFormHeaderFields(this.formId).subscribe(res=>{
      console.log("HEader_", res)
      this.showSMU =  res.find(x => x.standardField === 6) ? true : false; // smu 
      this.showWorkOrder = res.find(x => x.standardField === 7) ? true : false; // work order 
      this.showDate = res.find(x => x.standardField === 3) ? true : false; // start date
      //TT-5713 removed start date, work order, smu from array to make it editable
      this.headerFormList=res.filter(f=>f.standardField!=3 && f.standardField!=6 && f.standardField!=7);
      let arr_ =[...this.headerFormList];
      console.log("HEader_after_filter_", this.headerFormList)
      if(this.headerFormList.length<6){
        for (let index = this.headerFormList.length; index <= 6; index++) {
          let obj={
                  answer:"",
                  fieldname:"",
                  Id:0,
                  standardField:0,
                  qid:0,
                  order:0,
                }
          arr_.push(obj);
        }
        this.headerFormList = arr_;
      }
      console.log("HEader_after_add_", this.headerFormList)
      this.headerFormList.map(x=>{
        if (x.standardField == 1)
          x.answer = this._crypto.decrypt(this.form.Inspector);
        
        if(x.standardField==2)
          x.answer =this.form.RevisionNo;

        if(x.standardField==3)
          x.answer= this.form.FormStartDate;

        if(x.standardField==4)
          x.answer= this.form.EQCustomer + '/' + this.form.EQJobsite;

        if(x.standardField==5)
          x.answer=this.form.Serial;
      })
       if (!this.formQuestions || this.formQuestions.length === 0) return;
      this.formQuestions.map(q=>{
        let check =  this.headerFormList.find(y=>y.qid == q.QuestionId);
        if(check && check.Id > 0){
          check.fieldname = q.QTitle.length > 0 ? q.QTitle : "";
          check.answer= q.ModelAnswers[0].Answer.length > 0 ? q.ModelAnswers[0].Answer : "";
        }
      })
    })
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

//   LoadSelectedCatData(sectionId: number, QuestionID: number, UploadId: number){
//  // this._router.navigate(['/digitalform/fill', this.formId, this.uploadId,sectionId,QuestionID]);
//  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
//  // if(res=="True"){
//     this._router.navigate(['/digitalform/fill', this.formId, UploadId,sectionId,QuestionID]);
//   // }
//   // else{             
//   //  // window.open('/digitalform/fill/' + this.formId + '/' + UploadId + '/'+ sectionId + '/' + QuestionID,'_blank');
//   //   window.open('/digitalform/fill/' + this.formId + '/' + UploadId + '/'+ sectionId + '/' + QuestionID,);
//   // }
// });

// }

  LoadSelectedCatData(sectionId: number, QuestionID: number, UploadId: number){
    const dialogRef = this._dialog.open( DigitalFormSectionQuestionsComponent, {
      width: '70%',
      height: '70%',
      disableClose: true,
      data: {
        FormId: this.formId,
        SectionId: sectionId,
        QuestionID: QuestionID,
        UploadId: UploadId
      }
    });
    dialogRef.afterClosed().subscribe(r => {
      this.LoadFormUploadDetails();
    });
  }


  UpdateStatus(QuestionsOverAllStatus: number){
    if(QuestionsOverAllStatus == 1 && (this.form.OverAllInprogressCount != 0) && (this.form.FormStatusID == 2 || this.form.FormStatusID == 3)) {
      this.form.FormStatusID = 1;
      this.toastr.error("Form Status cannot be changed until all questions are moved from In Progress to Completed.");
    }
    else {
      this._formService.UpdateUploadFormStatus(this.uploadId, this.form.FormStatusID, QuestionsOverAllStatus).subscribe(res=>{
        if(res){
          this.toastr.success("Sucessfully update the status")
          this.LoadFormUploadDetails();
        }else{
          this.toastr.error("Unable to update the status")
        }
      });
    }
  }

  GeneratePDF(){
    //window.open(this.appUris.UCUri + 'api/DigitalFormIdentity/GetPdf?formId=' + this.formId + '&uploadId=' + this.uploadId, '_blank');
    window.open(this._appService.getBaseURL() + 'api/DigitalFormIdentity/GetPdf?formId=' + this.formId + '&uploadId=' + this.uploadId, '_blank');
  }

  UpdateInspectionSMU(event:any){
    this.InspectionSMU = event.target.value;
    this._formService.UpdateUploadInspectionSMU(this.InspectionSMU, this.uploadId).subscribe(res=>{
      if(res)
      this.toastr.success("Sucessfully Updated SMU")
    })
  }

  UpdateWorkOrder(event: any) {
    this.workOrder = event.target.value;
    this._formService.UpdateWorkOrder(this.workOrder, this.uploadId).subscribe(res => {
    if(res)
      this.toastr.success("Sucessfully Updated Work Order.")
    })
  }

  RefreshInspection(){
    this._formService.UpdateDFIInspection(this.uploadId).subscribe(res=>{
      if(res.m_Item1==true){
        this.toastr.success(res.m_Item2);
      }else{
        this.toastr.error(res.m_Item2);
      }
    })
  }

  UpdateInspectionDate(event:any){ 
    this.startDate=event.value
    var params: formUploadDate= new formUploadDate()
    params.startDate=this.startDate
    params.uploadId=this.uploadId
    this._formService.UpdateFormUploadDate(params).subscribe(res=>{
    if(res)
      this.toastr.success("Sucessfully Updated Start Date")
    })
  }
  
  AddToReportOptions(){
    //Create DFI Inspection Report Records for the form
    this._formService.DFIRportAddRecordsNewInspection(this.uploadId).subscribe(res=>{
      if(res==true){
        window.open('digitalform/reports/'+ this.formId+ '/'+ this.uploadId,'_blank');
      }  
    })
  }

  GetPdfDigitalForm(){
    this._formService.DFIRportAddRecordsNewInspection(this.uploadId).subscribe(res=>{
      if(res==true){
        // window.open(this.appUris.UCUri + 'api/DigitalFormIdentity/GetPdFDFIReports?FormUploadID=' + this.uploadId, '_blank');
        window.open(this._appService.getBaseURL() + 'api/DigitalFormIdentity/GetPdFDFIReports?FormUploadID=' + this.uploadId, '_blank');
      } 
    }) 
  }
  shouldShowTooltip(answer: string): boolean {
    if (!answer) return false;
    return answer.split('%').some(part => part.trim().length > 10);
  }
  getDisplayAnswer(answer: string): string {
    if (!answer) return '';
    const parts = answer.split('%');
    // truncate only the first long segment
    console.log('parts', parts);
    return parts.map(p => p.trim().length > 10 ? p.trim().substring(0, 10) + '...' : p.trim()).join(', ');
  }
}
